import React from 'react';
import SPAButton from './SPAButton';

interface PaginationControlsProps {
  canNextPage: boolean;
  canPreviousPage: boolean;
  onNextPage: () => void;
  onPageChange: (page: number) => void;
  onPreviousPage: () => void;
  pageCount: number;
  pageIndex: number;
}

const PaginationControls = ({
  canNextPage,
  canPreviousPage,
  onNextPage,
  onPageChange,
  onPreviousPage,
  pageCount,
  pageIndex,
}: PaginationControlsProps) => {
  if (pageCount <= 1) return null;

  const pages: (number | string)[] = [];

  for (let i = 0; i < pageCount; i++) {
    if (i === 0 || i === pageCount - 1 || Math.abs(i - pageIndex) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  return (
    <div className="tw-flex tw-items-center tw-justify-end">
      <div className="tw-flex tw-items-center tw-gap-1">
        <SPAButton disabled={!canPreviousPage} onClick={onPreviousPage}>
          Previous
        </SPAButton>
        {pages.map((page, idx) => {
          if (typeof page === 'string') {
            return (
              <span
                key={`ellipsis-${idx}`}
                className="tw-px-2 tw-text-spa-tertiary"
              >
                &hellip;
              </span>
            );
          }

          return (
            <SPAButton
              key={page}
              aria-current={page === pageIndex ? 'page' : undefined}
              variant={page === pageIndex ? 'primary' : 'secondary'}
              onClick={() => onPageChange(page)}
            >
              {page + 1}
            </SPAButton>
          );
        })}
        <SPAButton disabled={!canNextPage} onClick={onNextPage}>
          Next
        </SPAButton>
      </div>
    </div>
  );
};

export default PaginationControls;
